import {
  Accordion as AccordionRoot,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface AccordionEntry {
  title: string;
  content: string;
}

interface AccordionGroupProps {
  items: AccordionEntry[];
  /** Allow multiple items open at once. Default: false (single). */
  multiple?: boolean;
}

const AccordionGroup = ({ items, multiple = false }: AccordionGroupProps) => {
  return (
    <AccordionRoot type={multiple ? "multiple" : "single"} collapsible className="w-full">
      {items.map((item, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
          <AccordionTrigger className="font-headline text-base md:text-lg text-foreground py-5 hover:no-underline hover:text-accent transition-colors">
            {item.title}
          </AccordionTrigger>
          <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pb-5">
            {item.content}
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionRoot>
  );
};

export default AccordionGroup;
